import { memo, useCallback, useContext, useState } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { SensitiveActionModal } from 'src/components/shared/SensitiveActionModal'
import { CircleCancelMajor } from '@shopify/polaris-icons'
import { ContractorDetailsModalContext } from '../ContractorDetailsModal.context'

interface Props {
  onReject(): void
  isLoading: boolean
}

const RejectContractorComponent = ({ onReject, isLoading = false }: Props) => {
  const { statusIsUpdating } = useContext(ContractorDetailsModalContext)

  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const handleOpenConfirm = useCallback(() => {
    setIsConfirmOpen(true)
  }, [])

  const handleCloseConfirm = useCallback(() => {
    setIsConfirmOpen(false)
  }, [])

  return (
    <div css={tw`w-full bg-white`}>
      <Button
        fullWidth
        className={tw`px-8`}
        size="small"
        color="grey"
        onClick={handleOpenConfirm}
        endIcon={<CircleCancelMajor width={20} height={20} />}
        loading={isLoading}
        disabled={statusIsUpdating}
      >
        Reject contractor
      </Button>
      <SensitiveActionModal
        isOpen={isConfirmOpen}
        title="Reject contractor?"
        text="Are you sure you want to reject contractor?"
        submitLabel="Reject"
        onClose={handleCloseConfirm}
        onSubmit={onReject}
      />
    </div>
  )
}

export const RejectContractor = memo(RejectContractorComponent)
